function setupGalleryDots(dotsContainer) {
  if (dotsContainer.dataset.dotsBound) return;
  const gallery = dotsContainer.closest('slider-component');
  const dots = Array.from(dotsContainer.querySelectorAll('.product__gallery-dot'));
  if (!gallery || !dots.length) return;
  dotsContainer.dataset.dotsBound = 'true';

  function setActiveDot(index) {
    dots.forEach((dot, i) => {
      const isActive = i === index;
      dot.classList.toggle('is-active', isActive);
      if (isActive) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  }

  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      const target = document.getElementById(dot.dataset.target);
      if (!target || !gallery.slider) return;
      gallery.slider.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
    });
  });

  gallery.addEventListener('slideChanged', (event) => {
    setActiveDot(event.detail.currentPage - 1);
  });
}

function initGalleryDots() {
  document.querySelectorAll('.product__gallery-dots').forEach(setupGalleryDots);
}

initGalleryDots();
document.addEventListener('shopify:section:load', initGalleryDots);
